import { NgModule } from '@angular/core';
import { IconButtonModule } from '../../directives/icon-button/icon-button.module';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { BundledProductsCardsComponent } from './bundled-products-cards.component';
import { ActionButtonsService } from 'common/src/services/action-buttons.service';
import { RnplCommonModule } from 'common/src/modules';
import { NgxCurrencyModule } from 'ngx-currency-custom';


@NgModule({
  declarations: [
    BundledProductsCardsComponent
  ],
  exports: [
    BundledProductsCardsComponent
  ],
  imports: [
    IconButtonModule,
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    RnplCommonModule,
    RouterModule,
    NgxCurrencyModule,
  ],
  providers: [
    ActionButtonsService
  ]
})
export class BundledProductsCardsModule { }
